"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var tslib_1 = require("tslib");
var ui_box_1 = require("@hopin-team/ui-box");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var root_1 = require("./styled/root");
var Card = (0, styled_components_1.default)(ui_box_1.Box)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), root_1.rootStyles);
exports.Card = Card;
Card.defaultProps = {
    background: 'grey-white',
    cornerRadius: 'lg',
    level: 'low',
};
var templateObject_1;
//# sourceMappingURL=card.js.map